import Pill from '@/components/ui/Pill'
import Link from '@/components/ui/Link'

type ExploreButtonProps = {
  label: string
  link?: string
  invert?: boolean
  onClick?: () => void
}

export default function ExploreButton({ label, link, onClick, invert }: ExploreButtonProps) {
  return (
    <div className="flex justify-center py-16 md:py-20">
      {link ? (
        <Link href={link}>
          <Pill size="large" style="outlinePrimary" theme={invert ? 'dark' : 'light'}>
            {label}
          </Pill>
        </Link>
      ) : (
        <Pill
          onClick={onClick}
          size="large"
          style="outlinePrimary"
          theme={invert ? 'dark' : 'light'}
        >
          {label}
        </Pill>
      )}
    </div>
  )
}
